import { installAuthViewport } from '../common/authViewport'
import { toTraditional } from '../common/traditional'
import Vue from 'vue'
import VueRouter from 'vue-router'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import Recharge from '../pages/mine/Recharge.vue'/* 充值 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import TrcCard  from '../pages/mine/TrcCard.vue'/* 绑定银行卡界面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定虚拟货币界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import RechargeRecord from '../pages/mine/RechargeRecord.vue'
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import Account  from '../pages/mine/Account'/* 账户详情 */
import History from '../pages/history/index.vue' //黑料
import Trc20 from '../pages/mine/Trc20.vue'//虚拟货币提现
import Settrc from '../pages/mine/Settrc.vue'//设置虚拟货币地址


Vue.use(VueRouter)
const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{title:'熱門視頻'}},
    {path:'/Home',name:'home',component:Home,meta:{title:'熱門視頻'}},
	{path:'/Choose',name:'choose',component:Choose,meta:{title:'約會'}},
	{path:'/List',name:'list',component:List,meta:{title:'精選名單'}},
	{path:'/Profile',name:'profile',component:Profile,meta:{title:'詳細資料'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'我的'}},
    {path:'/Video',name:'video',component:Video,meta:{title:'視頻分類'}},
    {path:'/Game',name:'game',component:Game,meta:{title:'遊戲'}},
    {path:'/Login',name:'login',component:Login,meta:{title:'登入'}},
    {path:'/Register',name:'register',component:Register,meta:{title:'註冊'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'線上服務'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'線上服務'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:'設定'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'基本資料'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:'修改暱稱'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'修改性別'}},
    {path:'/Language',redirect:'/Mine'},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'充值'}},
    {path:'/SetPayPassword',redirect:'/Mine'},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'登入密碼'}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'遊戲詳情'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:'公告'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'視頻播放'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'銀行帳戶資料'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'綁定銀行帳戶'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'提現'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'個人報表'}},
    {path:'/RechargeRecord',name:'RechargeRecord',component:RechargeRecord,meta:{title:'充值記錄'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'提現記錄'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'投注記錄'}},
    {path:'/Account',name:'Account',component:Account,meta:{title:'帳戶記錄'}},
    {path:'/Guide',name:'Guide',component:()=>import('@/pages/home/guide'),meta:{title:'使用指南'}},
    {path:'/VipCard',name:'VipCard',component:()=>import('@/pages/mine/VipCard'),meta:{title:'會員卡'}},
    {path:'/History',name:'history',component:History,meta:{title:'視頻分類'}},
    {path:'/Trc20',name:'trc20',component:Trc20,meta:{title:'虛擬貨幣提現'}},
    {path:'/Settrc',name:'settrc',component:Settrc,meta:{title:'虛擬貨幣帳戶'}},
    {path:'/TrcCard',name:'trcCard',component:TrcCard,meta:{title:'綁定虛擬貨幣帳戶'}},
    {path:'/Torules',redirect:'/Mine'},
];

//生成路由实例
const router = new VueRouter({
    routes
})
router.beforeEach((to,from,next) => {         //修改标题路由配置加上这个
    const pageTitle = to.matched[0] && to.matched[0].meta ? to.matched[0].meta.title : ''
    document.title = toTraditional(pageTitle ? `${pageTitle} - SweetLove` : 'SweetLove')
    next()
})

installAuthViewport(router)

export default router
